import React  from 'react'
import Tooltip from '@mui/material/Tooltip';
import moment from 'moment'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const CertifiedUsers = ({certifiedUsersCount , loadingChart}) => {

    return (
        <>
                <h6>{ loadingChart ? <Skeleton width="5vw"/> : <> Certified Users </> }</h6>
            <div className='completeddf'>

            { loadingChart ? <>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
                <div className="completedlist" >
                    <div className='cmpbox'>
                    <h6><Skeleton width="5vw" highlightColor="#ffffff"/></h6>
                    </div>
                    <div className='perbox'>
                    <Skeleton width="50px" height="50px" baseColor="#3e4095" highlightColor="#ffffff50"/>
                    </div>
                </div>
            </>
            :
            <>
            {certifiedUsersCount && certifiedUsersCount.length > 0 &&
                    certifiedUsersCount.map((e,index)=>{
                        return(
                            <div className="completedlist" key={index}>
                                <div className='cmpbox'>
                                    <Tooltip title={e.name}> 
                                    <h6>{e.name}</h6>
                                    </Tooltip>
                                </div>
                                <div className='perbox'>
                                    <span>{e.certificates}</span>
                                </div>
                            </div>
                        )
                    })
            }
            </> }
            </div>
        </>
    )
}

export default CertifiedUsers
